export function Eyebrow({ children }: { children: string }) {
  return (
    <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-stone">
      <span className="h-px w-6 bg-signal" />
      {children}
    </span>
  )
}
